import RadioButton from './RadioButton';
import withLabel from '../Form/withLabel';
/**
 * 带文字的Radio组件
 */
var Radio = withLabel('Radio')(RadioButton);
Radio.displayName = 'Radio';
export default Radio;
//# sourceMappingURL=Radio.js.map